
<template>
    <div>
        <div class="carousel">
            <button @click="swipeToPrevious" class="nav-button left">&lt;</button>
            <div class="carousel-container">
                <transition :name="`carousel-${swipeDirection}`">
                    <div
                        class="carousel__content"
                        ref="carousel"
                    >
                        <!-- Affiche uniquement le contenu correspondant à l'index -->
                        <slot :current-index="currentImgIndex"></slot>
                    </div>
                </transition>
            </div>
            <button @click="swipeToNext" class="nav-button right">&gt;</button>
        </div>
        <div class="indicators">
            <span
                v-for="(_, i) in count"
                :key="i"
                @click="goTo(i)"
                :class="{ active: i === currentImgIndex }"
            ></span>
        </div>
    </div>
</template>

<script>
const LEFT_DIRECTION = "left";
const RIGHT_DIRECTION = "right";

export default {
    name: 'CarouselV5',
    data() {
        return {
            currentImgIndex: 0,
            swipeDirection: '',
            count: 0,
        }
    },
    mounted () {
        this.count = this.$refs.carousel.children.length;
        Array.from(this.$refs.carousel.children).forEach(child => {
            child.classList.add('hidden');
        })
        this.$refs.carousel.children[this.currentImgIndex].classList.remove('hidden');
    },
    computed: {},
    methods: {
        swipeToNext() {
            this.$refs.carousel.children[this.currentImgIndex].classList.add('hidden');
            if (this.currentImgIndex < this.count - 1) {
                this.currentImgIndex++;
            } else {
                this.currentImgIndex = 0;
            }
            this.swipeDirection = LEFT_DIRECTION;
            this.$refs.carousel.children[this.currentImgIndex].classList.remove('hidden');
        },
        swipeToPrevious() {
            this.$refs.carousel.children[this.currentImgIndex].classList.add('hidden');
            if (this.currentImgIndex > 0) {
                this.currentImgIndex--;
            } else {
                this.currentImgIndex = this.count - 1;
            }
            this.swipeDirection = RIGHT_DIRECTION;
            this.$refs.carousel.children[this.currentImgIndex].classList.remove('hidden');
        },
        selectCurrentImg(index) {
            if (index < this.currentImgIndex) {
                this.swipeDirection = RIGHT_DIRECTION;
            } else {
                this.swipeDirection = LEFT_DIRECTION;
            }
            this.currentImgIndex = index;
        },
        goTo(index) {
            //this.currentImgIndex = index;
            if (index !== this.currentImgIndex) {
                this.swipeDirection = index < this.currentImgIndex ? RIGHT_DIRECTION : LEFT_DIRECTION;
                this.currentImgIndex = index;
            }
        },
    }
}
</script>

<style scoped>
.carousel {
    height: 750px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
}
.carousel-container {
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
}
.carousel__content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.left {
    left: 0;
}

.right {
    right: 0;
}

.carousel__img {
    width: 100%;
}

.carousel-left-enter-active,
.carousel-left-leave-active,
.carousel-right-enter-active,
.carousel-right-leave-active {
    transition: transform 0.5s ease;
}

.carousel-left-leave-active,
.carousel-right-leave-active {
    position: absolute;
}

.carousel-left-enter {
    transform: translateX(100%);
}

.carousel-left-enter-to,
.carousel-right-enter-to {
    transform: translateX(0);
}

.carousel-right-enter {
    transform: translateX(-100%);
}

.carousel-left-leave-to {
    transform: translateX(-100%);
}

.carousel-right-leave-to {
    transform: translateX(100%);
}
.nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
    z-index: 10;
}
.indicators {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    z-index: 10;
}

.indicators span {
    width: 12px;
    height: 12px;
    margin: 0 5px;
    background: gray;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
}

.indicators .active {
    background: black;
}
</style>
